import mitt, { EventType } from "mitt";

interface Events extends Record<EventType, unknown> {
  "@procedure:updated": string;
}

const proceduresEvents = mitt<Events>();

export { proceduresEvents };
